import React from "react";
import { FiPhone, FiShoppingBag, FiArrowLeft } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import wazeImg from "../Images/waze.png";
import { useNavigate } from "react-router-dom";

const PHONE_NUMBER = "+972 52-747-7128";
const WHATSAPP_LINK = "https://wa.me/972527477128?text=" + encodeURIComponent("Hello! I would like to place an order.");
const WAZE_LINK = "https://waze.com/ul/hsvbby6yh6";

export default function CheckOut() {
  const navigate = useNavigate();
  const whatsappLink = WHATSAPP_LINK;

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* Back button */}
        <button onClick={() => navigate("/")} style={styles.backBtn}>
          <FiArrowLeft size={16} />
          Back to Home
        </button>

        {/* Icon */}
        <div style={styles.iconWrap}>
          <FiShoppingBag size={48} color="#c8a96e" />
        </div>

        {/* Heading */}
        <h1 style={styles.title}>Online Checkout Coming Soon</h1>
        <p style={styles.subtitle}>
          Our online checkout is currently being set up. In the meantime, you
          can place your order through any of the options below — we're happy
          to help!
        </p>

        <div style={styles.divider} />

        {/* Contact options */}
        <div style={styles.options}>
          {/* WhatsApp */}
          <a href={whatsappLink} target="_blank" rel="noreferrer" style={styles.optionCard}>
            <div style={{ ...styles.optionIcon, background: "#25D36620" }}>
              <FaWhatsapp size={28} color="#25D366" />
            </div>
            <div>
              <p style={styles.optionLabel}>WhatsApp</p>
              <p style={styles.optionValue}>{PHONE_NUMBER}</p>
              <p style={styles.optionHint}>Tap to chat with us</p>
            </div>
          </a>

          {/* Phone */}
          <a href={`tel:${PHONE_NUMBER.replace(/[\s-]/g, "")}`} style={styles.optionCard}>
            <div style={{ ...styles.optionIcon, background: "#3b82f620" }}>
              <FiPhone size={26} color="#3b82f6" />
            </div>
            <div>
              <p style={styles.optionLabel}>Phone Call</p>
              <p style={styles.optionValue}>{PHONE_NUMBER}</p>
              <p style={styles.optionHint}>Call us during working hours</p>
            </div>
          </a>

          {/* Waze directions */}
          <a href={WAZE_LINK} target="_blank" rel="noreferrer" style={styles.optionCard}>
            <div style={{ ...styles.optionIcon, background: "#34C75920" }}>
              <img src={wazeImg} alt="Waze" style={{ width: 28, height: 28 }} />
            </div>
            <div>
              <p style={styles.optionLabel}>Get Directions</p>
              <p style={styles.optionValue}>Open in Waze</p>
              <p style={styles.optionHint}>Navigate to our physical store</p>
            </div>
          </a>
        </div>

        <div style={styles.divider} />

        <p style={styles.footer}>
          We appreciate your patience and look forward to serving you.
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f9f7f4",
    padding: "40px 16px",
  },
  card: {
    background: "#fff",
    borderRadius: "16px",
    boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
    padding: "48px 40px",
    maxWidth: "580px",
    width: "100%",
    textAlign: "center",
  },
  backBtn: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    color: "#666",
    padding: "0 0 24px 0",
    fontWeight: "500",
  },
  iconWrap: {
    marginBottom: "20px",
  },
  title: {
    fontSize: "26px",
    fontWeight: "700",
    color: "#1a1a1a",
    margin: "0 0 12px",
  },
  subtitle: {
    fontSize: "15px",
    color: "#666",
    lineHeight: "1.7",
    margin: "0 auto",
    maxWidth: "440px",
  },
  divider: {
    height: "1px",
    background: "#f0ece6",
    margin: "28px 0",
  },
  options: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    textAlign: "left",
  },
  optionCard: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    padding: "16px 20px",
    borderRadius: "12px",
    border: "1px solid #f0ece6",
    background: "#fdfcfa",
    textDecoration: "none",
    color: "inherit",
    transition: "box-shadow 0.2s",
  },
  optionIcon: {
    width: "52px",
    height: "52px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  optionLabel: {
    fontWeight: "600",
    fontSize: "15px",
    color: "#1a1a1a",
    margin: "0 0 2px",
  },
  optionValue: {
    fontSize: "14px",
    color: "#444",
    margin: "0 0 2px",
    fontWeight: "500",
  },
  optionHint: {
    fontSize: "12px",
    color: "#999",
    margin: 0,
  },
  footer: {
    fontSize: "14px",
    color: "#999",
    margin: 0,
    fontStyle: "italic",
  },
};
